export default __webpack_public_path__ + "static/img4-c3e4e8af05ae91c9844f4641eba0bcd4.png";